export const enum InputBoxScriptType {
    NORMAL = "normal",
    SUBSCRIPT = "sub",
    SUPERSCRIPT = "super",
}
